import { render, staticRenderFns } from "./new-variation.vue?vue&type=template&id=709d87c7&"
import script from "./new-variation.vue?vue&type=script&lang=js&"
export * from "./new-variation.vue?vue&type=script&lang=js&"
import style0 from "./new-variation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports